import styled, { css } from "styled-components";
import { motion } from 'framer-motion';
import { cursorPointer, displayFlexWidthHeight, maxWidth } from "../../components/Layout";

type SectionType = {
    backgroundcolor: string
}



type LiType = {
    active: boolean
}

const flex = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const padding = css`
    padding: 0 3.8rem 0 3.8rem;
`

const marginTop = css`
    margin-top: 3rem;
`;


const liCss = css`
    border-bottom: 4px solid ${props => props.theme.colors.tertiary};
`


export const SHome = styled.main`
    ${displayFlexWidthHeight}
    div.container{
        ${maxWidth}
        ${padding}
        width: 100%;

        @media screen  and (max-width:850px){
            padding: 0 1.5rem 0 1.5rem;
        }
    }
    section.first-section{
        width: 100%;
        height: 100%;
        ${flex}
    }

`
export const ContainerBanner = styled.div`

     ${displayFlexWidthHeight}
     min-height: 36rem;
     flex-direction: row;
     transition: all 0.5s ease;
     @media screen and (max-width: 850px) {
        flex-direction: column-reverse;
    }
     
     div:first-child{
            width: 50%;
            transition: all 0.5s ease;
            @media screen and (max-width: 850px) {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    margin-bottom: 5rem;
                    width: 100%;
                }
            h2{
                font-size: 2rem;
                color: ${props => props.theme.colors.white}
            }
            h1{
                font-size: 3rem;
                color: ${props => props.theme.colors.tertiary};
    
                @media screen and (max-width: 1051px) {
                    font-size: 2.5rem;
                }
                @media screen and (max-width: 900px) {
                    font-size: 2rem;
                }
            }
            p{
                color: ${props => props.theme.colors.white};
                font-size: 1rem;
                margin-bottom: 1.5rem;
            }
       }

       div:last-child{
           width: 50%;
           height: 100%;
           display: flex;
           align-items: center;
           justify-content: center;
           transition: all 0.5s ease;
           @media screen and (max-width: 850px) {
                margin-bottom: 2rem;
                margin-top: 5rem;
                width: 100%;
            }

           span{
                width: 25rem;
                height: 25rem;
                border-radius: 20rem;
                background-color: ${props => props.theme.colors.white};
                border: 2px solid ${props => props.theme.colors.tertiary};
                display: flex;
                align-items: center;
                justify-content: center;
                @media screen and (max-width: 850px) {
                    height: 20rem;
                    width: 20rem;
                }
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: 0% 30%;
                    border-radius:100rem;
                }
           }

       }
`
export const SSection = styled(motion.section) <SectionType>`
    padding: 5rem 0 ;
    background-color: ${props => props.backgroundcolor};
     ${flex}
    width: 100vw;
    height: 100%;

    div.container{
        ${flex}
    }

    h1{
        color: ${props => props.theme.colors.white};
        font-size: 3rem;
        text-align: center;
        @media screen and (max-width: 720px) {
            font-size: 2.5rem;
        }
    }
    span.sub-title{
        color: ${props => props.theme.colors.tertiary};
        font-size: 1rem;
        text-align: center;
        width: 100%;
        span{
            color: ${props => props.theme.colors.white};
        }
    }
`

export const Description = styled.span<{ margin: string }>`
    font-size: 1rem;
    color: ${props => props.theme.colors.white};
    margin: ${props => props.margin};
    text-align: justify;

    @media screen and (max-width: 850px){
        text-align: center;
    }
    a{
        text-decoration: none;
        color: ${props => props.theme.colors.tertiary};
        font-weight: bold;

    }
   
`

export const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
   ${marginTop}    

    div{
        width: 50%;
        display: flex;
        flex-direction: column;

        @media screen and (max-width: 850px){
            width: 100%;
        }
        img{
            width: 100%;
            border-radius: 1rem;
            max-height: 25rem;
            height: 100%;
        }
    }

    div:first-child{
        align-items: flex-start;

        @media screen and (max-width: 850px){
            display: none;
        }
        
    }
    
`

export const FlexContainerGrid = styled(motion.div)`
    display:grid;
    grid-gap: 1.875rem;
    grid-template-columns: repeat(auto-fit, minmax(17.15rem, 1fr));
    justify-content: center;
    justify-items: center;
    width: 100%;
    height: 100%;
    ${marginTop} ;    
`

export const MenuPortifolio = styled.nav`
    width: 100%;
    margin-top: 2.5rem;

    ul{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;    
        list-style-type: none;

    }

`

export const ContainerImgPortifolio = styled(motion.div)`
    width: 100%;
    border-radius: 1rem;  
    max-width: 40rem;
    height: 100%;
    position: relative;

    &:hover{
        div.img{
             img{
                transform: scale(1.1);
                transition: all 0.5s ease;
            }
        }
        div.blackScreen{
            visibility: visible;
        }
    }

    div.img{
        width: 100%;
        height: 100%;
        border-radius: 1rem;  
        overflow: hidden;
        img{
            width: 100%;
            height: 100%;
            max-width: 100%;
            object-fit: contain;
            border-radius: 1rem;  
        }
    }

    div.blackScreen{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.8);
        visibility: hidden;
        border-radius: 1rem;  
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;

        div:first-child{
            height: 85%;
            width: 100%;
            border-radius: 1rem;  
            display:flex;
            align-items: center;
            justify-content: center;

        a{
            text-decoration: none;
            &:first-child{
                margin-right: 0.8rem;
            }
            button{
                border: none;
                display:flex;
                align-items: center;
                justify-content: center;
                padding: 0.5rem;
                width:100%;
                background-color: ${props => props.theme.colors.white};
                border-radius: 10rem;
                font-size: 0.8rem;
                color: #000000;
              
                ${cursorPointer}
                font-weight: bold;

                &:hover{
                    background-color: ${props => props.theme.colors.tertiary};
                    color:${props => props.theme.colors.white} ;

                    svg{
                        color:${props => props.theme.colors.white} ;
                    }
                }
                svg{
                    margin-right: 0.5rem;
                }
            }

        }
    }

        div:last-child{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width:100%;
            height: 15%;
            padding: 0 1rem;
            h3{
                font-size: 1rem;
                color: ${props => props.theme.colors.white};

                @media screen and (max-width:500px) {
                    font-size: 0.8rem;
                }
            }
            a{
                font-size: 0.8rem;
                text-decoration: none;
                font-weight: bold;
                color: ${props => props.theme.colors.white};
                
                ${cursorPointer}

                @media screen and (max-width:500px) {
                    font-size: 0.6rem;
                }
                
            }
        
        }
    }


`

export const Li = styled.li<LiType>`

    color: ${props => props.active ? props.theme.colors.tertiary : props.theme.colors.white};
    margin: 0 1.5rem;
    height: 2rem;
    text-transform: uppercase;
    font-size: 0.85rem;
    font-weight: bold;
    transition: all 0.2s ease;
    text-align: center;
    cursor: pointer;
    ${props => props.active && liCss}

    @media screen  and (max-width:380px){
        margin: 0 1rem;
    }
    &:hover{
        ${liCss}
        color: ${props => props.theme.colors.tertiary} ;
    }

`

export const FlexContainerGridImages = styled(FlexContainerGrid)`
    margin-top: 2rem;
    grid-template-columns: repeat(auto-fit, minmax(26rem, 1fr));

    @media screen  and (max-width:984px){
        grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
    }

    @media screen  and (max-width:370px){
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

`

export const ContactIntroduction = styled(motion.div)`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    div.first{
        display: flex;
        flex-direction: column;
        h3{
            color: ${props => props.theme.colors.white};
            font-size: 1.5rem;
            @media screen and (max-width: 500px){
                text-align: center;
            }
        }

        span.dev{
            color: ${props => props.theme.colors.tertiary};
            margin-bottom: 2rem;
            font-size: 1rem;
            @media screen and (max-width: 500px){
                text-align: center;
            }
        }

        ul{
            list-style-type: none;

            li{
                color: ${props => props.theme.colors.white};
                font-size: 1rem;

                &:not(:first-child){
                    margin-top: 0.5rem;
                }
                @media screen and (max-width: 500px){
                    text-align: center;
                }
                div{
                    margin-top: 2rem;
                    a{
                        color: ${props => props.theme.colors.white};

                        &:first-child{
                            margin-right: 1rem;
                        }
                        
                        &:hover{
                            color: ${props => props.theme.colors.tertiary};
                        }
                    }
                }

                span{
                    color: ${props => props.theme.colors.tertiary};
                }
        
            }
        }
    }

  
`

export const Form = styled(motion.form)`
    width:100%;
    height:100%;

    div{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;

        @media screen and (max-width: 500px){
            flex-direction: column;
        }

        &.container-button{
            justify-content: flex-start;
            @media screen and (max-width: 500px){
                justify-content: center;
             }
        }
    }
    
    button{
        margin-top: 1rem;
       height: 3.5rem;
    }
`

export const DivStyleWidth = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
` 